$(document).on('change-counter', '#form-rent-request[data-type="days"] [data-cart="qty"]', function (e, data) {
	let $container = $(this),
		$input = $container.find('input'),
		val = data.value,
		prices = $container.data('prices'),
		price = 0
	;

	for (let p of prices) {
		let days_from = parseInt(p.days_from);
		let days_to = parseInt(p.days_to);

		if (
			(!days_from || val >= days_from)
			&&
			(!days_to || val <= days_to)
		) {
			price = p.price;
		}
	}

	let $total = $(this).closest("#form-rent-request").find(".total-area");
	let $totalValue = $(this).closest('#form-rent-request').find('[data-total]');

	if (val) {
		$total.show();
		$totalValue.text(output_numbers(val * price));
	} else {
		$total.hide();
	}
});

$(document).on('input', '#form-rent-request[data-type="days"] [data-cart="qty"] input', function (e, data) {
	let $container = $(this).closest('[data-cart="qty"]');
	let val = parseInt($(this).val());
	let min = parseInt($(this).attr('min'));
	let max = parseInt($(this).attr('max'));

	if (val < min) val = min;
	if (val > max) val = max;

	if ($(this).val() != val) {
		$(this).val(val);
	}

	$container.trigger('change-counter', [{
		value: val
	}]);
});

